import { memo } from 'react'

import css from './empty.module.scss'
import { EmptyType } from './empty.type'

/** Компонент Пустого состояния (Empty). 
* @param {string} image - Ссылка на изображение, связанное с пустым состоянием.
* @param {string} title - Текстовое сообщение о пустом состоянии.
* @param {string} size - Размер изображения.
* @param {string} color - Цвет текста.
* @param {string} fontSize - Размер шрифта текста.
*/
export default memo(({ image, title, size = "200px", color = '#000', fontSize = '16px' }: EmptyType) => {
    return (
        <div className={css.wrapper}>
            <div className={css.container}>
                <img src={`${image}`} alt="Данные отсутствуют" style={{ height: `${size}` }} />
                <div className={css.title} style={{ color: `${color}`, fontSize: `${fontSize}` }}>{title}</div>
            </div>
        </div>
    )
})